import React, { Component } from "react";
import { FiChevronRight } from "react-icons/fi";
import { Redirect } from "react-router";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import Image from "../../../base/features/micro/Image";
import SimpleLabel from "../../../base/features/micro/SimpleLabel";
import {
  addConnection,
  connectionDetail,
  connectionTypes,
  deleteConnection,
  editConnection,
} from "./services";

class ConnectionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      connectionId:
        window.location.pathname.split("/")[4] === "add"
          ? null
          : window.location.pathname.split("/")[4],
      shopUid: window.location.pathname.split("/")[2],
      value: "",
      title: "",
      redirect: false,
      types: null,
      selectedType: null,
      index: 1,
    };
  }
  componentDidMount() {
    this.getConnectionTypes();
    if (this.state.connectionId) {
      this.getConnectionDetail();
    }
  }
  getConnectionTypes() {
    connectionTypes().then((items) => {
      items && this.setState({ types: items });
    });
  }
  getConnectionDetail() {
    connectionDetail(this.state.shopUid, this.state.connectionId).then(
      (items) => {
        items &&
          this.setState({
            index: items.index,
            title: items.title,
            value: items.value,
            selectedType: items.contact_type,
          });
      }
    );
  }
  editConnectionProperties() {
    let params = {
      value: this.state.value,
      title: this.state.title,
      index: this.state.index,
      contact_type: this.state.selectedType.uid,
    };
    editConnection(this.state.shopUid, this.state.connectionId, params).then(
      (items) => {
        items &&
          this.setState({
            redirect: true,
          });
      }
    );
  }
  add_connection() {
    let params = {
      value: this.state.value,
      title: this.state.title,
      index: this.state.index,
      contact_type: this.state.selectedType.uid,
    };
    addConnection(this.state.shopUid, params).then((items) => {
      if (items) {
        this.setState({
          redirect: true,
        });
      }
    });
  }
  delete_connection() {
    this.setState({ acceptModal: false, pending: true });
    deleteConnection(this.state.shopUid, this.state.connectionId).then(
      (items) => {
        Swal.fire({
          text: "با موفقعیت حذف شد",
          icon: "success",
          timer: 3000,
          confirmButtonText: "تایید",
        }).then(() => this.setState({ redirect: true }));
      }
    );
  }
  render() {
    return (
      <div className="container-fluid">
        {this.state.redirect && (
          <Redirect to={`/dashboard/${this.state.shopUid}/connections`} />
        )}
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "99999" }}
        >
          <div className="col-auto align-self-center px-0">
            <FiChevronRight
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bold mb-0">
              {this.state.connectionId
                ? "ویرایش راه ارتباطی"
                : "راه ارتباطی جدید"}
            </h1>
          </div>
          <div className="col-auto text-center align-self-center px-0">
            <button
              onClick={() =>
                this.state.connectionId
                  ? this.editConnectionProperties()
                  : this.add_connection()
              }
              className="btn fs-6 p-0 fw-bold mb-0 color-main disabled-color"
              disabled={!this.state.selectedType || !this.state.value}
            >
              ذخیره
            </button>
          </div>
        </header>
        <div className="row mx-0" style={{ marginTop: "80px" }}>
          <p className="fw-bold fs-6">نوع ارتباط</p>
          <div
            className="col-12 px-0"
            style={{
              overflow: "scroll hidden",
              whiteSpace: "nowrap",
            }}
          >
            {this.state.types &&
              this.state.types.map((type, t) => (
                <div
                  className={`d-inline-block rounded14 px-3 py-2-3 ms-4 ${
                    this.state.selectedType &&
                    this.state.selectedType.uid === type.uid
                      ? "border-main"
                      : "border"
                  }`}
                  onClick={() => this.setState({ selectedType: type })}
                >
                  <Image
                    imageHeight={"40"}
                    imageWidth={"40"}
                    extraClassName={"rounded-3 p-2 img-contain bg-color-main"}
                    imgClassName={"img-cover"}
                    imageUri={type.icon.icon_128}
                  />
                  <span className="fw-bold fs-5 me-2 ms-4">{type.title}</span>
                </div>
              ))}
          </div>
          <div className="col-12 px-0 my-4 position-relative">
            <input
              className="form-control p-3 small rounded14"
              value={this.state.value}
              onChange={(e) => this.setState({ value: e.target.value })}
              placeholder="جزئیات"
            />
            {this.state.value && <SimpleLabel text="جزئیات" />}
          </div>
          <div className="col-12 px-0 py-3">
            <p className="fw-bolder">ترتیب قرارگیری</p>
          </div>
          <div className="col-12 px-0 align-self-center text-center">
            <select
              onChange={(e) => this.setState({ index: e.target.value })}
              class="form-select select-dropdown-none text-center bg-none px-4 py-2 w-auto d-inline-block"
            >
              {this.props.location.state &&
                this.props.location.state.connections.map((connection, c) => (
                  <option
                    className="text-center"
                    selected={c + 1 === this.state.index}
                    value={c + 1}
                  >
                    {c + 1}
                  </option>
                ))}
              {this.props.location.state &&
                this.props.location.state.connections &&
                !this.state.connectionId && (
                  <option
                    className="text-center"
                    selected={
                      this.props.location.state.connections.length + 1 ===
                      this.state.index
                    }
                    value={this.props.location.state.connections.length + 1}
                  >
                    {this.props.location.state.connections.length + 1}
                  </option>
                )}
            </select>
          </div>
        </div>
        {this.state.connectionId && (
          <div
            className="row mx-0 p-4 position-fixed border-top border-light"
            style={{ bottom: "0", left: "0", right: "0" }}
          >
            <div className="col-12 px-0">
              <button
                className="btn rounded28 py-2-3 fw-bold border text-danger w-100"
                onClick={() => this.setState({ acceptModal: true })}
              >
                حذف راه ارتباطی
              </button>
            </div>
          </div>
        )}
        {this.state.acceptModal && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
            isOpen={this.state.acceptModal}
            toggle={() => this.setState({ acceptModal: false })}
          >
            <ModalBody className="row mx-0 p-4">
              <div className="col-12 px-1 mb-3">
                <p className="fw-bolder">حذف راه ارتباطی</p>
                <p className="text-muted">
                  آیا از حذف راه ارتباطی فعلی اطمینان دارید؟
                </p>
              </div>
              <div className="col-6 px-1">
                <button
                  className="btn py-2 w-100 text-danger fw-bold"
                  onClick={() => this.delete_connection()}
                >
                  بله
                </button>
              </div>
              <div className="col-6 px-1">
                <button
                  className="btn py-2 w-100 rounded28 border text-muted fw-bold"
                  onClick={() => this.setState({ acceptModal: false })}
                >
                  انصراف
                </button>
              </div>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

export default ConnectionDetail;
